import styled from 'styled-components';
import { InvalidConfigurationModalContentStyled } from '../InvalidConfigurationModalContentStyled';

export const InvalidConfigurationModalContentStyledAP = styled(InvalidConfigurationModalContentStyled)``;
